import {createModel} from "@rematch/core";

const alert = createModel({
  state: {
    type: "",
    delay: 2000,
    messages: []
  },
  reducers: {
    showAlert: (state: any, type: any, message: any) => ({
      ...state,
      type,
      delay: 2000,
      messages: [
        ...state.messages,
        {
          message,
          type
        }
      ]
    }),
    closeAlert: (state: any, message: any) => {
      let newMessages = [...state.messages];

      let targetIndex = state.messages.findIndex((m: any) => message === m);
      if (targetIndex > -1) {
        newMessages.splice(targetIndex, 1);
      }

      return {
        ...state,
        messages: newMessages
      };
    }
  }
});

export default alert;
